import React, { useContext, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Box, CircularProgress } from '@mui/material';
import mixpanel from 'mixpanel-browser';
import StoreContext from '../../react-core-lib/components/app/store-context';
import DisplayHandout from '../../components/authenticated/handout/display-handout';
import useFetchHandoutData from './use-fetch-handout-data';
import ErrorMessage from './error-message';

const HandoutContent = observer(({ linkId, clinicData, show3DModel, showMainIllustration, showTutorialVideo }) => {
    const { contentStore, imageStore } = useContext(StoreContext);
    const error = useFetchHandoutData(contentStore, imageStore, linkId);
    const hasTrackedRef = useRef(false);
    console.warn('clinic details! ', clinicData);
    // Adjusted check to include data availability
    const isLoading = !contentStore.isInitialized || !contentStore.handoutData || contentStore.handoutData.length === 0;

    // Track handout open via public link
    useEffect(() => {
        if (!isLoading && contentStore.handoutData?.length > 0 && !hasTrackedRef.current) {
            hasTrackedRef.current = true;
            const handoutTitles = contentStore.handoutData
                .filter(Boolean)
                .map((h) => h.contentName)
                .join(', ');

            mixpanel.track('PublicHandoutOpened', {
                linkId: linkId,
                handoutCount: contentStore.handoutData.filter(Boolean).length,
                handoutTitles: handoutTitles,
                clinicName: clinicData?.clinicName || null,
                source: clinicData?.source || 'unknown',
            });
            console.log('[Mixpanel] Tracked PublicHandoutOpened:', linkId);
        }
    }, [isLoading, contentStore.handoutData, linkId, clinicData]);

    if (error) {
        return <ErrorMessage message={error} />;
    }

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    // Render DisplayHandout only when data is available
    return (
        <Container maxWidth="md" sx={{ width: '100%', overflowY: 'auto', backgroundColor: 'white' }}>
            {contentStore.handoutData.map((handout, index) =>
                handout ? (
                    <Box key={index} sx={{ my: 2 }}>
                        <DisplayHandout
                            handoutData={handout}
                            clinicData={clinicData}
                            show3DModel={show3DModel}
                            showMainIllustration={showMainIllustration}
                            showTutorialVideo={showTutorialVideo}
                        />
                    </Box>
                ) : null,
            )}
        </Container>
    );
});

export default HandoutContent;
